import React from "react";

import Heading from "../../home/components/Heading";
import Footer from "../../home/components/Footer";

import ContentSection from "../../home/components/ContentSection";

const headingStyle = { fontWeight: "bold", fontSize: 16 };
const Main = (props) => {
  return (
    <div>
      <Heading {...props} showButtons={false} />
      <ContentSection>
        <div style={{ fontSize: 14 }}>
          <Content />
        </div>
      </ContentSection>
      <Footer />
    </div>
  );
};

export default Main;

export const Content = () => (
  <div>
    <div style={headingStyle}>Information Required Before Starting</div>
    <ul>
      <li>
        Obtain your portfolio reports for every <u>month end</u> in your
        analysis period; for example, an analysis period of Dec 31, 2017 to Feb
        28, 2019 will require 15 reports. A report must contain the end of month
        overall portfolio value, the amounts and exact dates of any portfolio
        transfers (contributions and withdrawals) and management fees.
        Transactions within the portfolio, such as dividends and asset
        sales/purchases are <u>not</u> transfers and are not required.
      </li>
      <li>
        Do not include any transfers on or before the close of the starting
        month, Dec 31, 2017 in the preceding example. The earliest permitted
        starting date is Nov 30, 2006.
      </li>
    </ul>
    <div style={headingStyle}>Specify Your Analysis Period</div>
    <ul>
      <li>
        Your analysis period must start at a month end and finish at a month
        end; for example, Dec 31, 2017 to Feb 28, 2018.
      </li>
      <li>
        The RoboPPA™ is currently limited to analysis periods starting Nov 30,
        2006 or later. Analysis period finishing dates are typically limited to
        two months prior to the date you sign in. If you select dates that are
        out of range, RoboPPA™ will default to the permissible dates.
      </li>
    </ul>

    <div style={headingStyle}>
      Name Your Portfolio and Calculate Your Portfolio Value (Privacy) Factor
    </div>
    <ul>
      <li>
        You may use any portfolio name that is meaningful to you. Do not reveal
        any portfolio information regarding the manager, institution, or tax
        status, for example.
      </li>
      <li>
        The portfolio’s true starting value is obtained from your manager/broker
        report for the starting month end; for example, Dec 31, 2017. That
        report’s closing date may not be exactly the last day of the month if
        the market is closed on the last day, but its portfolio closing value is
        used as the analysis period’s true starting value.
      </li>
      <li>
        You must calculate your “portfolio value factor” prior to proceeding. It
        is obtained by simply dividing your true starting portfolio value by
        100; for example, on Dec 31, 2017, a portfolio valued at $114,550 in
        total has a factor of 1,145.50. Do <u>not</u> compute another portfolio
        factor from other months’ reports.
      </li>
      <li>
        You will not reveal this factor and therefore your true portfolio value
        will be known only to you.
      </li>
      <li>
        The RoboPPA™ will automatically allocate a standard $100 portfolio
        starting value and the remaining standardized data entries are described
        below.
      </li>
    </ul>
    <div style={headingStyle}>
      Determine Standardized Month End Portfolio Values, Transfers, and Manager
      Fees
    </div>
    <ul>
      <li>
        True portfolio values are obtainable from your manager/broker reports
        and must be the total value at the close of each month. A report’s
        closing date may not be exactly the last day of the month if the market
        is closed, but its portfolio closing value is used as the analysis
        month’s value.
      </li>
      <li>
        A monthly report should show all foreign assets valued in Canadian
        Dollars (CAD) and a resulting total portfolio value in CAD. Do{" "}
        <u>not</u> mix foreign currencies with Canadian dollars, before
        standardization.
      </li>
      <li>
        Each month-end dollar value is standardized using the single portfolio
        value factor. A standardized portfolio value is obtained by simply
        dividing the true portfolio value for the month by the portfolio value
        factor. For example, a Mar 31, 2018 true value of $121,145 is a
        standardized value of $121,145/1145.5=$105.76.
      </li>
      <li>
        The contributions and withdrawals are transfers to or from you or
        another portfolio or agency, regardless of purpose, and may be in the
        form of cash or securities. Items such as dividends, asset
        sales/purchases transacted inside the portfolio are NOT transfers. The
        standardized transfers are obtained by simply dividing the true transfer
        amount by the same portfolio value factor of, for example, 1145.5;
        transfer dates are also required.
      </li>
      <li>
        Standardized management fees and their pay dates are required entry
        regardless of whether the fees were paid directly from the portfolio or
        from a contribution transfer. Standardized fees are obtained by simply
        dividing the true fee by the same portfolio value factor of, for
        example, 1145.5. Note that management fees do <u>not</u> necessarily
        require a transfer entry because the fee is taken from the portfolio’s
        cash account.
      </li>
      <li>
        If you paid a management fee and it is <u>not shown</u> in your
        portfolio report, enter the fee and enter a contribution of equal value.
      </li>
    </ul>
    <div style={headingStyle}>Prepare an Excel File in Advance</div>
    <ul>
      <li>
        You have the option of preparing your input file before using RoboPPA™.
        This has several advantages including easy import of the required data
        for analysis and ease of updating your inputs for additional RoboPPA™
        analyses.
      </li>
      <li>
        Open a new Excel workbook and enter your portfolio’s standardized data
        in the following Column order.
        <ul>
          <li>
            Column 1: Date in the format MM/DD/YYYY. You may enter the same date
            in more than one row and every row must have a date.
          </li>
          <li>
            Column 2: Portfolio Month End Closing Value corresponding to the
            month end date in Column 1 and the same Row. All months within the
            analysis interval must have a month end date and closing value.
          </li>
          <li>
            Column 3: Cash Contributions, corresponding to the date in Column 1
            and the same Row
          </li>
          <li>
            Column 4: Contributed Securities Value, corresponding to the date in
            Column 1 and the same Row
          </li>
          <li>
            Column 5: Cash Withdrawn, corresponding to the date in Column 1 and
            the same Row
          </li>
          <li>
            Column 6: Withdrawn Securities Value, corresponding to the date in
            Column 1 and the same Row
          </li>
          <li>
            Column 7: Manager Fees Paid, corresponding to the date in Column 1
            and the same Row
          </li>
        </ul>
      </li>
      <li>
        You can either choose to save the file as a .csv file and upload it or
        copy the cells directly from Excel and paste them into the data entry
        window.
      </li>
      <li>
        If you have not standardized your portfolio values based on the privacy
        factor, you will be given the option to have it automatically converted.
      </li>
    </ul>
    <div style={headingStyle}>Specify Your Benchmarks</div>
    <ul>
      <li>
        Specify the Portfolio Benchmark that best describes your starting or
        desired portfolio allocations for your portfolio, by filling in the
        boxes in RoboPPA™. It is important that your benchmark specification
        accurately reflects your passive investment portfolio choice.
        Allocations must add to 100%. These need not be identical to your
        portfolio’s actual starting allocations.
      </li>
      <li>
        You may also select a maximum of three additional benchmarks from the
        provided list. The benchmark performance results may be useful to you
        for evaluating the actual asset allocations of your portfolio.
      </li>
    </ul>
    <div style={headingStyle}>
      Aggregating Two or More Portfolios for Analysis
    </div>
    <ul>
      <li>
        You may combine two or more portfolios into a single portfolio for
        analysis, prior to entering any data. Basically, this involves adding
        together the respective portfolios’ numbers, as follows. Do not
        standardize the numbers before the addition.
      </li>
      <li>
        For end of month aggregate portfolio value, simply add the values from
        the portfolios’ reports and repeat for each month in the specified
        analysis period.
      </li>
      <li>
        For portfolio contributions and withdrawals, enter the dates and
        transfer amounts from all portfolios as if they were made to a single
        portfolio. Separate entries are required because the contributions and
        withdrawals are likely to occur on different dates. Transfers between
        portfolios do <u>not</u> require entries.
      </li>
      <li>
        For management fees, enter the dates and fees amounts for each portfolio
        as if they were for a single portfolio. Separate entries are required
        because the fees are likely to occur on different dates. These entries
        are required regardless of whether the fees were paid directly from a
        portfolio or from a contribution.
      </li>
      <li>
        The RoboPPA™ single portfolio charge applies but the resulting analysis
        applies to the entire aggregated portfolio and the results are not
        separable.
      </li>
    </ul>

    <div style={headingStyle}>What to Do with Non-Traded Portfolio Assets</div>
    <ul>
      <li>
        Non-traded assets must have an assessed value for each month in the
        analysis period.
      </li>
      <li>
        Cash like assets, such as GSCs, are effectively market traded because
        their value and interest are reported as part of your portfolio’s value.
        Other alternative and real assets such as real estate and timber land
        likely require an estimated market value entry or adjustment or must be
        eliminated from the portfolio’s values and any affected transfers.
      </li>
      <li>
        If values are missing, make an estimate of the missing values and add
        that to the end of month portfolio value. This must be done for all
        months in the analysis period and revised in subsequent months of the
        analysis period.
      </li>
      <li>
        Non-traded assets are subject to large errors in assessed value. Review
        any values provided in your reports and reassess them if you think they
        are in error and add (subtract) the value increase (decrease) to (from)
        the total portfolio value. This must be done for all months in the
        analysis period and carried forward to subsequent months in the analysis
        period.
      </li>
      <li>
        If a non-traded asset is sold (or purchased), the report should show its
        sale (purchase) price added to (removed from) the portfolio’s cash
        account. The total portfolio value will change if the non-traded asset
        is sold for more (less) than its value in the month.
      </li>
    </ul>
    <div style={headingStyle}>
      What to Do with Foreign Assets That Do Not Have Canadian Dollar Values
    </div>
    <ul>
      <li>
        All portfolio assets must have Canadian dollar (CAD) values and must not
        be expressed in different currencies. If the reports have values that
        are not converted, you must do the conversion yourself and add those
        values to the CAD values of the other assets, resulting in a total
        portfolio value in CAD only. We recommend using the selling (bid)
        foreign exchange value.
      </li>
    </ul>
    <div style={headingStyle}>
      Converting Your Standardized Portfolio’s RoboPPA™ Results to Your Actual
      Portfolio’s Results
    </div>
    <ul>
      <li>
        The report’s analysis is based on your portfolio’s standardized values.
        Any dollar values contained in the report can be converted to your true
        portfolio’s equivalent values by multiplying by your portfolio factor.
        This includes portfolio values and management fees.
      </li>
      <li>
        Many reported numbers are expressed in % format; for example, the
        portfolio’s annualized % return. These numbers will be the same for your
        true portfolio and the standardized portfolio and therefore do not
        require multiplication by your portfolio factor.
      </li>
    </ul>
  </div>
);



// WEBPACK FOOTER //
// ./src/portfolioEntryWizard/components/Instructions.js